export const UploadStatus = {
  UPLOADING: "Uploading",
  PENDING: "Pending",
  ERROR: "Error",
  COMPLETED: "Completed",
  DONE: "Done",
  PROCESSING: "Processing",
  CANCELLED: "Cancelled",
  CANCELLING: "Cancelling",
  PAUSED: "Paused",
  RESUMED: "Resumed"
};
